import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#757575",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.095 10.467s-.543 6.735-.858 9.572c-.15 1.355-.987 2.149-2.358 2.174-2.609.047-5.22.05-7.829-.005-1.319-.027-2.142-.831-2.289-2.162-.317-2.862-.857-9.58-.857-9.58M20.48 7.238H3.52M17.212 7.239a1.648 1.648 0 0 1-1.615-1.324l-.243-1.216a1.28 1.28 0 0 0-1.237-.949H9.884a1.28 1.28 0 0 0-1.237.949l-.243 1.216A1.648 1.648 0 0 1 6.79 7.239"
    }, null, -1)
  ]))]))
}
export default { render: render }